import { Component, OnInit } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'fc-app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.scss'],
    standalone: false
})
export class ConfirmationComponent implements OnInit {

  public onClose: Subject<boolean> = new  Subject<boolean>();    
  title: string = '';
  message: any;
  cancelString: string = '';
  yes: string = '';
  warning: string = '';
  autoClose: boolean = false;
  showYesButton: boolean = true;
  primaryColor: string = '';
  
  constructor(private modalRef:BsModalRef) {       
  }

  ngOnInit(): void {    
      this.onClose = new Subject();
      if (this.autoClose === true) {
          setTimeout(() => this.cancel(), 2500); 
      }
      setTimeout(() => {
        if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
          const colorFromStorage = localStorage.getItem('primaryCssColor');
          this.primaryColor = colorFromStorage ? colorFromStorage.toString() : 'rgb(0, 134, 113)';
          document.documentElement.style.setProperty('--primary-color', this.primaryColor);
        }
      }, 0);
  }

  cancel() {
    this.onClose.next(false);
    this.modalRef.hide();
  }

  confirmed() {
    this.onClose.next(true);
    this.modalRef.hide();
  }  
}